<!-- 快捷定位 -->
<template>
  <div class="bread-box">
    <span><i class="el-icon-location-information"></i>您当前所在位置：</span>
    <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        :to="item.path"
        v-for="item in breadcrumbs"
        :key="item.name"
        >{{ item.name }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.bread-box {
  display: flex;
  align-items: center;
  font-size: 14px;

  span i {
    margin-right: 10px;
    font-size: 18px;
  }
}
</style>
